// Accounts created through the custom StackUp signup flow never supply a name:
// the account is built from just an email and password. On a User that leaves
// firstName/lastName null; on a Participation the backend has to write the
// literal string "unspecified" into the NOT NULL first_name/last_name columns
// (Participation#set_default_values). Rendering either raw produces a blank
// heading or "unspecified unspecified", so fall back to the username — the one
// identity such an account is guaranteed to have. Mirrors the backend's
// User#full_name and Participation#full_name.
//
// Kept out of the API response on purpose: admin screens edit first_name and
// last_name directly and must keep showing the real stored values.
const UNSPECIFIED = 'unspecified'

const displayName = (
  first?: string | null,
  last?: string | null,
  username?: string | null
): string => {
  const parts = [first, last]
    .map((part) => part?.trim())
    .filter((part) => part && part !== UNSPECIFIED)

  return parts.length > 0 ? parts.join(' ') : (username ?? '')
}

// For records coming from the API, which uses snake_case.
export const participantDisplayName = (participant: {
  first_name?: string | null
  last_name?: string | null
  username?: string | null
}): string =>
  displayName(
    participant.first_name,
    participant.last_name,
    participant.username
  )

// For the session/profile shape, which uses camelCase.
export const userDisplayName = (
  user?: {
    firstName?: string | null
    lastName?: string | null
    username?: string | null
  } | null
): string => displayName(user?.firstName, user?.lastName, user?.username)
